export enum ApplicationType_Enum{
    "Unset" = 0,
    "Eligibility" = 1,
    "Full Proposal" = 2,
    "Quick Quote" = 3,
    "Enquiry" = 4,
    "Business" = 5,
}